<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="Practice Areas" src="/images/sub/sub-visual.jpg"></sub-visual>
        </template>
        <template #contentsImmersive>
            <div class="grey">
                <v-container class="px-0 px-md-12px">
                    <v-tabs grow hide-slider class="immersive-tabs">
                        <v-tab to="/practice/corporate">기업법무</v-tab>
                        <v-tab to="/practice/dispute">소송 / 분쟁</v-tab>
                    </v-tabs>
                </v-container>
            </div>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first pb-0">
            <div class="tit-wrap tit-wrap--sm">
                <h3 class="tit tit--xl tit--point line-height-11">
                    <span>소송 / 분쟁</span>
                    <span class="tit--point__circle" data-aos="zoom-in"></span>
                </h3>
            </div>
            <div class="txt line-height-15 overflow-hidden">
                <!-- <div v-html="practice?.section1?.txt.replace(/\n/gi, '<br/>')" data-aos="fade" data-aos-duration="600"></div> -->
                <div v-html="practice?.section1?.txt.replace(/\n/gi, '<br/>')" data-aos="fade" data-aos-duration="600" data-aos-anchor-placement="top-bottom"></div>
            </div>
        </page-section>

        <page-section class="page-section--sm page-section--last">
            <div class="pb-16px pb-md-20px">
                <h4 class="tit tit--xs">주요 업무분야</h4>
            </div>

            <v-divider style="border-width: 2px 0 0" class="grey darken-4" />
            <v-expansion-panels flat multiple class="font-secondary">
                <v-expansion-panel v-for="(section, index) in practice?.section2" :key="index">
                    <v-expansion-panel-header class="pa-12px px-md-20px py-md-24px border-b">
                        <div class="tit tit--xxs font-weight-medium">{{ section?.title }}</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="grey lighten-5">
                        <div class="px-12px py-16px px-md-20px py-md-24px px-lg-60px py-lg-40px border-b">
                            <!-- <page-section v-for="(section, index) in lawyer.section2" :key="index" class="page-section--xxs pb-0" :class="{ 'pt-0': index == 0 }"> -->
                            <page-section class="page-section--xxs py-0">
                                <template #pageSectionImmersive>
                                    <div v-for="(columns, index) in section?.columns" :key="index" :class="{ 'pt-8px pt-md-10px': index != 0 }">
                                        <v-row class="row--xs txt txt--sm line-height-15">
                                            <v-col>
                                                <v-row class="row--xs">
                                                    <v-col cols="auto">·</v-col
                                                    ><v-col
                                                        ><div>{{ columns?.txt }}</div></v-col
                                                    >
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </template>
                            </page-section>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
    },
    data() {
        return {
            practice: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { practice } = await api.v1.practice.get({ params: { code: "international", local: "ko" } });

            this.practice = practice;
        },
    },
};
</script>

<style lang="scss" scoped></style>
